import styled from 'styled-components'

export default styled.div`
  background: url('${STATICS_PATH}images/adverts/reklama-horizontal.png') center no-repeat;
  bottom: 0;
  height: 20px;
  position: absolute;
  right: 0;
  width: 35px;
  z-index: inherit;
`
